import { Injectable } from '@angular/core';

/**
 * Round-trip context for the Ajanvaraus (schedule) <-> Ajanvarausprofiili
 * (user availability) quick-link. Mirrors ProcedureBookingService: a
 * providedIn:'root' singleton backed by sessionStorage, so the context
 * survives the route change / component teardown but stays scoped to the tab.
 *
 * The schedule stores where to return (returnUrl) plus the exact view it left
 * (viewType + viewDate) so the round trip can restore it. Selected user columns
 * and other filters are restored separately from localStorage['AL_SCHEDULE'].
 */
export interface PresenceBookingContext {
  returnUrl: string;
  sourceLabel: string;
  viewType: number;
  viewDate: string;
}

@Injectable({
  providedIn: 'root'
})
export class PresenceBookingService {
  private readonly storageKey = 'AL_PRESENCE_BOOKING';
  private session: Storage = sessionStorage;

  setContext(context: PresenceBookingContext): void {
    this.session.setItem(this.storageKey, JSON.stringify(context));
  }

  getContext(): PresenceBookingContext | null {
    const data = this.session.getItem(this.storageKey);
    if (!data) {
      return null;
    }
    try {
      return JSON.parse(data) as PresenceBookingContext;
    } catch {
      return null;
    }
  }

  clearContext(): void {
    this.session.removeItem(this.storageKey);
  }
}
